<template>
  <div class="update">
    <!-- 心愿进度 -->
    <TitleBar :barObj="wishBar" />
    <Progress
      :list="progressList"
      @refresh="refresh"
      :isUpdate="isUpdate"
      v-if="progressList.length !== 0"
    />
    <!-- 暂无进度 -->
    <van-empty
      description="暂无进度"
      v-if="progressList.length === 0"
      class="custom-image"
      image="http://img.wish.hebyun.com.cn/images/empty_state.png"
    />
    <div class="line" style="margin-top:26px"></div>
    <!-- 完成过程 -->
    <TitleBar :barObj="finishBar" />
    <!-- 时间 -->
    <div class="time">
      <div class="title">
        时间
      </div>
      <div class="input" @click="showPicker = true">
        <input type="text" placeholder="请选择时间" disabled v-model="date" />
        <van-icon name="arrow" size="16px" color="#333" />
      </div>
    </div>
    <!-- 内容 -->
    <div class="textarea">
      <div class="title">
        <span>内容</span>
      </div>
      <div class="textarea_box">
        <van-field
          v-model="content"
          row="5"
          type="textarea"
          autosize
          show-word-limit
          maxlength="200"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <!-- 图片 -->
    <div class="imgUpload">
      <div class="title">图片</div>
      <van-uploader
        v-model="imgUrlList"
        :max-size="5 * 1024 * 1024"
        max-count="12"
        multiple
        preview-full-image
      >
        <van-image src="http://img.wish.hebyun.com.cn/images/upload_add.png" />
      </van-uploader>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <Button :button="button" @click.native="updateBtn" />
      <div class="checkbox">
        <van-checkbox v-model="checked" label-disabled>
          <span>勾选确定心愿已完成</span>
          <template #icon="props">
            <img
              class="img-icon"
              :src="props.checked ? activeIcon : inactiveIcon"
            />
          </template>
        </van-checkbox>
      </div>
    </div>
    <!-- 进度 -->
    <div class="confirm">
      <van-popup v-model="showConfirm">
        <div class="confirm_box">
          <div class="text">
            请再次确认心愿是否完成，确定完成后心愿进度 将不可更新。
          </div>
          <div class="btns">
            <Button :button="cancleBtn" @click.native="handleCancle" />
            <Button :button="sureBtn" @click.native="handleSure" />
          </div>
        </div>
      </van-popup>
    </div>
    <div class="comment">
      <van-popup v-model="isShowComment" round :close-on-click-overlay="false">
        <div class="comment_box">
          <div class="comment_header">心愿完成评价</div>
          <div class="textarea_box">
            <van-field
              v-model="comment"
              row="5"
              type="textarea"
              maxlength="200"
              placeholder="请输入内容"
              show-word-limit
            />
          </div>
          <div class="btns" style="display:flex">
            <Button
              :button="cancleCommentBtn"
              @click.native="handleCommentCancle"
            />
            <Button
              :button="sureCommentBtn"
              @click.native="handleSureCommentBtn"
            />
          </div>
        </div>
      </van-popup>
    </div>

    <!-- Loading -->
    <van-overlay :show="showLoading">
      <van-loading type="spinner" />
    </van-overlay>

    <van-popup v-model="showPicker" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :columns-order="['year', 'month', 'day']"
        :formatter="formatter"
        @cancel="onTimeOut"
        @confirm="onTimeIn"
        @changeFn="onShift"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
import Progress from "@/components/Progress";
import TitleBar from "@/components/TitleBar";
import Button from "@/components/Button";

export default {
  name: "update",
  data() {
    return {
      title: "进度",
      button: "更新进度",
      finishBar: {
        img: "http://img.wish.hebyun.com.cn/images/book.png",
        title: "完成过程",
      },
      wishBar: {
        img: "http://img.wish.hebyun.com.cn/images/heart.png",
        title: "心愿进度",
      },
      wishid: "", //心愿id
      user_id: 0, //党员或机构用户id，如果0表示当前用户
      date: "",
      content: "", //进度
      iscompelete: 1, //申请完成0不申请
      comment: "", //评论内容（当勾选完成内容时填写）
      imgs: "", //json串
      cancleBtn: "取消",
      sureBtn: "确定,去评价",
      cancleCommentBtn: "取消",
      sureCommentBtn: "确定",
      showConfirm: false, //是否展示确认弹框
      isShowComment: false, //是否展示评论弹框
      progressList: [], //进度数据
      isUpdate: true, //是否是更新页面
      imgUrlList: [],
      showLoading: false, //loading
      checked: false, //复选框状态
      activeIcon: "http://img.wish.hebyun.com.cn/images/confirm_active.png",
      inactiveIcon: "http://img.wish.hebyun.com.cn/images/confirm.png",
      showPicker: false,
      //   时间选择器
      currentDate: new Date(),
      maxDate: new Date(),
      changeDate: new Date(),
    };
  },
  created() {
    this.wishid = this.$route.query.id;
    this.queryProgress();
  },
  components: {
    Progress,
    TitleBar,
    Button,
  },
  methods: {
    // 确认弹框的取消按钮
    handleCancle() {
      this.showConfirm = false;
    },
    // 确认弹框的确定按钮
    handleSure() {
      // 点击确认按钮后，出现评论弹框
      this.showConfirm = false;
      this.isShowComment = true;
    },
    // 评论框取消按钮
    handleCommentCancle() {
      this.showConfirm = true;
      this.isShowComment = false;
    },
    // 评论框确定按钮
    async handleSureCommentBtn() {
      if (this.comment.length === 0) {
        this.$toast("请输入内容");
        return;
      }
      this.showLoading = true;
      let token = localStorage.getItem("uploadToken");
      let imgUrlList = [];
      if (this.imgUrlList.length != 0) {
        imgUrlList = await this.$api.uploadFile(this.imgUrlList, token);
        imgUrlList = JSON.stringify(imgUrlList);
      }
      let datas = {
        wishid: this.wishid,
        date: this.date,
        content: this.content,
        iscompelete: 1,
        comment: this.comment, //评价内容
        imgs: imgUrlList, // 心愿图片json;
      };
      await this.$api.updateProcess(datas);
      this.showLoading = false;
      this.$toast("更新成功");
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },
    // 时间选择 弹框的确认按钮
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      return val;
    },
    // 取消
    onTimeOut() {
      this.showPicker = true;
    },
    // 格式转化
    onShift() {
      this.changeDate = this.currentDate; // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
    },
    // 确认
    onTimeIn() {
      this.date = this.timeFormat(this.currentDate);
      this.showPicker = false;
    },
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let day = time.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
    // 更新进度
    async updateBtn() {
      if (this.date.trim().length === 0) {
        this.$toast("请选择时间");
        return;
      }
      if (this.content.trim().length === 0) {
        this.$toast("请输入进度描述");
        return;
      }
      let token = localStorage.getItem("uploadToken");

      let imgUrlList = [];
      if (this.imgUrlList.length != 0) {
        imgUrlList = await this.$api.uploadFile(this.imgUrlList, token);
        imgUrlList = JSON.stringify(imgUrlList);
      }
      // 点击按钮的时候，复选框勾选并且评论为空
      if (this.checked === true && this.comment.trim().length === 0) {
        this.showConfirm = true;
      } else {
        this.$dialog
          .confirm({
            message: "确认提交吗?管理员审核通过后可见",
          })
          .then(() => {
            let datas = {
              wishid: this.wishid,
              date: this.date,
              content: this.content,
              iscompelete: 0,
              comment: "", //评价内容
              imgs: imgUrlList, // 心愿图片json;
            };
            this.$api.updateProcess(datas);
            this.$toast("更新成功");
            setTimeout(() => {
              this.$router.go(-1);
            }, 2000);
          });
      }
    },
    // 查询某个心愿中某个党员或机构的进度 wishid:心愿id  user_id:党员或机构用户id，如果0表示当前用户
    async queryProgress() {
      let data_s = {
        wishid: this.wishid,
        user_id: this.user_id,
      };
      let { data } = await this.$api.queryProcess(data_s);
      this.progressList = data;
    },
    refresh() {
      this.queryProgress();
    },
  },
};
</script>
<style lang="scss">
/* 全局样式 */
.update {
  /deep/ .van-empty {
    padding: 10px 0 0;
  }
  .titleBar {
    height: 34px;
    line-height: 34px;
  }
}
.update .footer .btn {
  width: 210px;
  height: 36px;
  margin-bottom: 15px;
  margin: 20px auto;
}
.update .footer .btn span {
  font-size: 15px;
}
.update .confirm .btn {
  margin: 40px 0 0 0;
  width: 120px;
  height: 30px;
}
.update .confirm .btn span {
  font-size: 14px;
}
.update .comment .btn {
  margin: 0 auto 0;
  width: 120px;
  height: 30px;
}
.update .comment .btn span {
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.update {
  padding: 12.5px 21px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff8d6;
  min-height: 100vh;
}
.line {
  width: 375px;
  height: 4px;
  background-color: #ffffff;
  margin-left: -21px;
  margin-bottom: 10px;
}
.confirm {
  .confirm_box {
    width: 334px;
    height: 142px;
    background-color: #f9f1c6;
    padding: 20px;
    box-sizing: border-box;
    .text {
      font-size: 14px;
      line-height: 18.5px;
      color: #666666;
      text-align: left;
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  /deep/.van-popup {
    border-radius: 5px;
  }
}
.comment {
  .comment_box {
    width: 334px;
    height: 284.5px;
    background-color: #fff8d6;
    border-radius: 10px;
    padding: 0 20px 20px;
    box-sizing: border-box;
    .comment_header {
      font-size: 15px;
      color: #333333;
      width: 100%;
      text-align: center;
      padding: 15px 0;
    }
    .textarea_box {
      flex: 1;
      position: relative;
      width: 295px;
      height: 160px;
      background-color: #ffffff;
      border-radius: 10px;
      font-size: 13px;
      line-height: 1;
      color: #999999;
      overflow: hidden;
      margin-bottom: 22px;
      /deep/.van-cell {
        height: 160px;
        padding: 9px;
        box-sizing: border-box;
      }
      /deep/.van-field__body {
        height: 130px;
      }
      /deep/.van-field__control {
        height: 130px;
        font-size: 14px;
        color: #666666;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.imgUpload {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  width: 335px;
  .title {
    font-size: 15px;
    line-height: 1;
    color: #333333;
    width: 1;
    margin-right: 10px;
  }
  /deep/.van-uploader {
    flex: 1;
  }
  /deep/.van-image {
    width: 68px;
    height: 68px;
  }
  /deep/.van-uploader__preview {
    margin: 0 7px 9px 0;
  }
  /deep/.van-uploader__preview:nth-child(4n) {
    margin: 0 0 9px 0;
  }
  /deep/.van-uploader__preview-delete {
    width: 15px;
    height: 15px;
    right: -5px;
    top: -5px;
    border-radius: 50%;
  }
  /deep/.van-uploader__preview-delete-icon {
    right: -1px;
    top: 0px;
  }
}
.checkbox {
  position: relative;
  .img-icon {
    height: 16px;
  }
  /deep/.van-checkbox__label {
    font-size: 11px;
    line-height: no;
    letter-spacing: -0.5px;
    color: #999999;
  }
  /deep/.van-checkbox {
    justify-content: center;
  }
  /deep/.van-checkbox__icon {
    width: 16px;
    height: 16px;
  }
}
.textarea {
  display: flex;
  justify-content: space-between;
  .title {
    font-size: 15px;
    line-height: 1;
    color: #333333;
    width: 32px;
    margin-right: 10px;
  }
  .textarea_box {
    flex: 1;
    position: relative;
    width: 295px;
    // height: 120px;
    background-color: #ffffff;
    border-radius: 10px;
    font-size: 13px;
    line-height: 1;
    color: #999999;
    overflow: hidden;
    margin-bottom: 22px;
    /deep/.van-cell {
      // height: 120px;
      padding: 9px;
      box-sizing: border-box;
    }
    /deep/.van-field__body {
      min-height: 90px;
    }
    /deep/.van-field__control {
      min-height: 90px;
      font-size: 14px;
      color: #666666;
      line-height: 1.4;
    }
  }
}
.time {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;
  width: 335px;
  .title {
    font-size: 15px;
    line-height: 1;
    color: #333333;
    width: 32px;
    margin-right: 10px;
  }
  .input {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 285px;
    height: 25px;
    background-color: #ffffff;
    border-radius: 10px;
    padding-left: 10px;
    input {
      text-align: left;
      font-size: 14px;
      color: #000000;
      background-color: transparent;
      border: 0;
      outline: 0;
      width: 100%;
    }
  }
}
</style>
